import $ from "jquery";

const quickLinkObject = {
  variable: {
    url: window.location.href,
    hideQuickLinksContainerDesktop: null,
    hideQuickLinksContainerMobile: null,
  },
  methods: {
    autoHide: function () {
      const $stickyDiv = $(".quick__links__inner");
      const $availableJobs = $(".availableJobs--sticky-section");
      let scrollTimeout;
      let isHovered = false;

      const isDesktop = () => $(window).width() >= 768;
      const isMobile = () => $(window).width() < 768;

      const applyConfigHide = () => {
        if ((isDesktop() && quickLinkObject.variable.hideQuickLinksContainerDesktop) ||
            (isMobile() && quickLinkObject.variable.hideQuickLinksContainerMobile)) {
          $stickyDiv.addClass("hideQuickLinks");
        } else {
          $stickyDiv.removeClass("hideQuickLinks");
        }
      };

      if ($stickyDiv.length > 0) {
        applyConfigHide();
        $stickyDiv.on("mouseenter", function () {
          isHovered = true;
        }).on("mouseleave", function () {
          isHovered = false;
        });

        // R4 perf: raw scroll events can fire far more often than the
        // browser can paint. rAF-throttling how often this callback runs
        // doesn't change its behavior (the 1200ms hide-timer logic below
        // only needs to be reset regularly during active scrolling, not on
        // literally every event) - it just avoids the redundant reads/
        // writes this did on every single scroll tick.
        let quickLinksScrollTicking = false;
        $(window).on("scroll", function () {
          if (quickLinksScrollTicking) {return;}
          quickLinksScrollTicking = true;
          window.requestAnimationFrame(function () {
            quickLinksScrollTicking = false;
            clearTimeout(scrollTimeout);
           if ((isDesktop() && !quickLinkObject.variable.hideQuickLinksContainerDesktop) ||
               (isMobile() && !quickLinkObject.variable.hideQuickLinksContainerMobile)) {
             $stickyDiv.removeClass("hideQuickLinks");
           }

            scrollTimeout = setTimeout(function () {
              if (!isHovered) {
                $stickyDiv.addClass("hideQuickLinks");

                if ($(window).width() <= 768) {
                  $availableJobs.css("bottom", "0px");
                }
              }
            }, 1200);

            if (!isHovered) {
              if ($(window).width() <= 768) {
                $availableJobs.css("bottom", "86px");
              }
            }
          });
        });
      } else {
        if ($(window).width() <= 768) {
          $availableJobs.css("bottom", "0px");
        }
      }
    },

    init: function () {
       const getBoolValue = (name) => {
       const el = document.querySelector(`input[name="${name}"]`);
       return el ? el.value === "true" : false;
      };

      quickLinkObject.variable.hideQuickLinksContainerDesktop = getBoolValue("hideQuickLinksDesktop");
      quickLinkObject.variable.hideQuickLinksContainerMobile = getBoolValue("hideQuickLinksMobile");

      this.autoHide();

      $('.quick__links__inner .generic__links').on('click', function(e){
        var quickLinkText = $(this).attr('data-link-text');
        var obj = quickLinkObject.methods.dataLayerObj(quickLinkText);
        createDataLayer('QuickLinks_'+quickLinkText, obj);
      });
    },

    dataLayerObj: function(buttonText) {
      var obj = {
        'articleName': "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': buttonText,
        'pageSection': "Quick Links",
        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ?
          quickLinkObject.variable.url.includes("blog") ? "Blogs" : "Other Pages" : "Blog Details Page",
        'planOption': "",
        'productCategory': "",
        'productName': "",
        'question': "",
        'searchTerm': "",
        'videoTitle': "",
        'bannerName': "",
        'bannerType': ""
      };
      return obj;
    }
  },
};

$(() => {
  if ($(".quickLinks__section").length > 0) {
    quickLinkObject.methods.init();
  } else {
    const $availableJobs = $(".availableJobs--sticky-section");
    if ($(window).width() <= 768) {
      $availableJobs.css("bottom", "0px");
    }
  }
});

